import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertTriangle, Brain, HeartCrack } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-dark-900" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <FadeIn data-id="element-119">
          <h2 className="text-3xl md:text-4xl text-center mb-16" data-id="element-120">
            Vivir con un narcisista no es solo tener una "relación tóxica"
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-121">
          <FadeIn delay={0.1} className="bg-dark-800 p-8 rounded-lg border border-dark-700 hover:border-gold/30 transition-colors" data-id="element-122">
            <Brain className="w-10 h-10 text-gold mb-6" data-id="element-123" />
            <h3 className="text-xl mb-4" data-id="element-124">Guerra Psicológica</h3>
            <p className="text-offwhite/70 font-light leading-relaxed" data-id="element-125">
              Es una guerra psicológica que reprograma tu cerebro. Has sido
              víctima del gaslighting (donde te hacen dudar de lo que viste y
              oíste), de la triangulación y del descarte emocional.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-dark-800 p-8 rounded-lg border border-dark-700 hover:border-gold/30 transition-colors" data-id="element-126">
            <AlertTriangle className="w-10 h-10 text-gold mb-6" data-id="element-127" />
            <h3 className="text-xl mb-4" data-id="element-128">Estado de Supervivencia</h3>
            <p className="text-offwhite/70 font-light leading-relaxed" data-id="element-129">
              El problema no es que seas débil. El problema es que tu sistema
              nervioso está atrapado en un estado de supervivencia. Tu cuerpo
              detecta peligro cada vez que vibra tu teléfono móvil.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-dark-800 p-8 rounded-lg border border-dark-700 hover:border-gold/30 transition-colors" data-id="element-130">
            <HeartCrack className="w-10 h-10 text-gold mb-6" data-id="element-131" />
            <h3 className="text-xl mb-4" data-id="element-132">Vínculo de Trauma</h3>
            <p className="text-offwhite/70 font-light leading-relaxed" data-id="element-133">
              Tu mente ha creado un "vínculo de trauma" tan fuerte como una
              adicción química. Por eso, aunque sabes que debes irte o mantener
              el contacto cero, sientes que te falta el aire cuando lo intentas.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}